"use strict";

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Espace_1 = __importDefault(require("../../Model/Espace"));

var Event = /*#__PURE__*/function (_Espace_1$default) {
  _inherits(Event, _Espace_1$default);

  var _super = _createSuper(Event);

  function Event(props) {
    _classCallCheck(this, Event);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      collectionName: 'events',
      orderDirection: (props === null || props === void 0 ? void 0 : props.orderDirection) || 'desc',
      orderField: (props === null || props === void 0 ? void 0 : props.orderField) || 'createdAt'
    }));
  }

  return _createClass(Event);
}(Espace_1.default);

exports.default = Event;